<script setup>
import { useI18n } from 'vue-i18n';
import MessagesApi from 'dashboard/api/inbox/message';
import { useAlert } from 'dashboard/composables';
import { useMessageContext } from '../provider.js';
import {
  downloadFromResponse,
  downloadFromUrl,
} from 'dashboard/helper/downloadHelper';

import FileIcon from 'next/icon/FileIcon.vue';
import Icon from 'next/icon/Icon.vue';

const { id, conversationId, attachments } = useMessageContext();
const { t } = useI18n();

const downloadAttachments = async () => {
  try {
    const response = await MessagesApi.downloadAttachments(
      conversationId.value,
      id.value
    );
    downloadFromResponse(response, 'attachments.zip');
  } catch (error) {
    useAlert(t('CONVERSATION.ERROR_DOWNLOADING_FILE'));
  }
};

const delay = ms =>
  new Promise(resolve => {
    setTimeout(resolve, ms);
  });

const downloadSingleAttachment = async attachment => {
  const filename = attachment.fileName || null;
  await downloadFromUrl(attachment.dataUrl, filename);
  await delay(500);
};

const downloadAllIndividually = async () => {
  await attachments.value.reduce(async (previousPromise, attachment) => {
    await previousPromise;
    try {
      await downloadSingleAttachment(attachment);
    } catch (error) {
      useAlert(t('CONVERSATION.ERROR_DOWNLOADING_FILE'));
    }
  }, Promise.resolve());
};
</script>

<template>
  <div
    class="h-9 bg-n-alpha-white gap-2 overflow-hidden items-center flex px-2 rounded-lg border border-n-container"
  >
    <FileIcon class="flex-shrink-0" file-type="7z" />
    <span
      v-tooltip="t('CONVERSATION.DOWNLOAD_ATTACHMENTS_TOOLTIP')"
      class="flex-1 min-w-0 text-sm max-w-36 text-n-slate-12 cursor-pointer"
      @click="downloadAllIndividually"
    >
      {{ t('CONVERSATION.DOWNLOAD_ATTACHMENTS') }}
    </span>
    <a
      v-tooltip="t('CONVERSATION.DOWNLOAD_ATTACHMENTS_AS_ZIP')"
      class="flex-shrink-0 size-9 grid place-content-center cursor-pointer text-n-slate-11 hover:text-n-slate-12 transition-colors"
      @click.prevent="downloadAttachments"
    >
      <Icon icon="i-lucide-download" />
    </a>
  </div>
</template>
